<div class="container py-3">
<!-- Header -->
<div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="m-0 fw-bold">Notifications</h4>
    <i class="bi bi-trash fs-4 text-danger"></i>
</div>

<!-- Tabs -->
<div class="d-flex mb-3">
    <button class="btn btn-primary flex-grow-1 me-1">Activity</button>
    <button class="btn btn-outline-primary flex-grow-1">Messages</button>
</div>

<!-- Notifications List -->
<ul class="list-group">
    <!-- Example Item -->
    <li class="list-group-item d-flex align-items-start" *ngFor="let interaction of getAllInteractions()">
        <div class="profile-picture me-3">
            <img src="https://via.placeholder.com/60" alt="Client">
        </div>
        <div class="w-100">
            <div class="d-flex justify-content-between">
            <span class="text-muted small"></span>
            <span class="text-muted small">{{interaction.date}}</span>
            </div>
            <p class="mb-1">
            <i class="bi bi-file-text text-primary me-1"></i>
            <strong>{{interaction.action}}</strong> {{interaction.consult}}
            </p>
            <!-- [class]="getIcon(interaction.category).css" -->

<!--             <i *ngIf="interaction.category == 'Videocall'" class="fa fa-headset fs-18"></i>
            <i *ngIf="interaction.category == 'Checkpoint'" class="fa fa-flag-checkered fs-18"></i>
            <i *ngIf="interaction.category == 'studentVisa'" class="fa fa-graduation-cap"></i>
            <i *ngIf="interaction.category == 'Question'" class="fa fa-circle-question fs-18"></i>
            <i *ngIf="interaction.category == 'Seguro' || interaction.category == 'Seguro Médico'" class="fa fa-suitcase-medical fs-18"></i>
            <i  *ngIf="interaction.category == 'Follow-Up' || interaction.category == 'Follow-up' || interaction.category == 'Follow-up (email)'" class="fas fa-reply fs-18"></i>
            <i  *ngIf="interaction.category == 'Communication' || interaction.category == 'communication'" class="icon f7-icons text-color-yellow">ellipses_bubble_fill</i>
            <i *ngIf="interaction.category == 'Minuta'" class="fa fa-file-alt"></i>
            <i *ngIf="interaction.category == 'Budget'" class="fas fa-file-invoice-dollar"></i>
            <i *ngIf="interaction.category == 'Payment'" class="fa fa-credit-card"></i>
            <i *ngIf="interaction.category == 'Omnibus' || interaction.category == 'Seguro médico' || interaction.category == 'Seguro medico'" class="fa-solid fa-suitcase-medical"></i>
            <i *ngIf="interaction.category == 'Calendly' || interaction.category == 'calendly'" class="fas fa-calendar-check fs-18"></i>
            <i *ngIf="interaction.category == 'onboarding' || interaction.category == 'Onboarding'"class="fas fa-snowboarding"></i>
            <i *ngIf="interaction.category == 'Guide' || interaction.category == 'Guía PDF'"class="fas fa-file-pdf"></i>
            <i class="icon f7-icons text-color-green">person_crop_circle_fill_badge_plus</i> */ -->

            <app-smart-text [limit]="200" class="small  mb-0" [text]="interaction.comments"></app-smart-text>
            <p class="small text-muted mb-0">
            {{interaction.category}}
            </p>
        </div>
    </li>
    <!-- Repeat for more items -->
     <li *ngIf="clientInteractions.length==0">No hay interacciones</li>
</ul>
</div>


<mat-accordion>
    <mat-expansion-panel hideToggle class="media new" *ngFor="let interaction of getUserVisibleInteractions()">
      <mat-expansion-panel-header>
        <div class="settings-main-icon me-4 mt-1">
            <div class="avatar avatar-md bg-primary-transparent text-primary">
                <i *ngIf="interaction.category == 'Videocall'" class="fa fa-headset fs-18"></i>
                <i *ngIf="interaction.category == 'Checkpoint'" class="fa fa-flag-checkered fs-18"></i>
                <i *ngIf="interaction.category == 'studentVisa'" class="fa fa-graduation-cap"></i>
                <i *ngIf="interaction.category == 'Question'" class="fa fa-circle-question fs-18"></i>
                <i *ngIf="interaction.category == 'Seguro' || interaction.category == 'Seguro Médico'" class="fa fa-suitcase-medical fs-18"></i>
                <i  *ngIf="interaction.category == 'Follow-Up' || interaction.category == 'Follow-up' || interaction.category == 'Follow-up (email)'" class="fas fa-reply fs-18"></i>
                <i  *ngIf="interaction.category == 'Communication' || interaction.category == 'communication'" class="fas fa-comment-dots fs-18"></i>
                <i *ngIf="interaction.category == 'Minuta'" class="fa fa-file-alt"></i>
                <i *ngIf="interaction.category == 'Budget'" class="fas fa-file-invoice-dollar"></i>
                <i *ngIf="interaction.category == 'Payment'" class="fa fa-credit-card"></i>
                <i *ngIf="interaction.category == 'Omnibus' || interaction.category == 'Seguro médico' || interaction.category == 'Seguro medico'" class="fa-solid fa-suitcase-medical"></i>
                <i *ngIf="interaction.category == 'Calendly' || interaction.category == 'calendly'" class="fas fa-calendar-check fs-18"></i>
                <i *ngIf="interaction.category == 'onboarding' || interaction.category == 'Onboarding'"class="fas fa-snowboarding"></i>
                <i *ngIf="interaction.category == 'Guide' || interaction.category == 'Guía PDF'"class="fas fa-file-pdf"></i>
            </div>
        </div>

        <div class="media-body">
            <div class="media-contact-name">
                <span  *ngIf="interaction.category">{{interaction.category}}</span>
                <span>
                    <app-date-render class="text-tiny" date="{{interaction.date}}" [format]="'tiny'"></app-date-render>
                </span>
            </div>
            <p>
                <!-- <app-subtext class="text-tiny" *ngIf="interaction.action" [limit]="getCharacterLimit()" [text]="interaction.action"></app-subtext>
                <app-subtext class="text-tiny" *ngIf="!interaction.action && interaction.consult" [limit]="20" [text]="interaction.consult"></app-subtext>
                <app-subtext class="text-tiny" *ngIf="!interaction.action && !interaction.consult && interaction.comments" [limit]="35" [text]="interaction.comments"></app-subtext> -->
                
            </p>
        </div>

      </mat-expansion-panel-header>

        <div class="margin-top-1rem" *ngIf="selected">
            <span>{{selected}}</span>
        </div>

        <span *ngIf="interaction.name && interaction.lastname">
            <i class="fas fa-user-circle icon icon-gray" matTooltip="{{getFullName(interaction)}}"></i>
            <span>{{getFullName(interaction)}}</span>
        </span>

        <span *ngIf="!isDateEmpty(interaction.dueDate)">
            <button type="button" class="icon icon-gray" mat-button><mat-icon>date_range</mat-icon></button>
            <app-date-render class="text-tiny" [date]="interaction.dueDate" [format]="'short'"></app-date-render>
        </span>

        <div class="flex flex-column">

            <div *ngIf="interaction.comments">
            <mat-label style="font-size: 10px;">Comments:</mat-label>
            <mat-chip-list (click)="openDetails(interaction.comments)">
                <mat-chip class="chip-edit" color="primary" (click)="openDetails(interaction.comments)"> 
                <app-smart-text [limit]="20" [text]="interaction.comments"></app-smart-text>
                </mat-chip>
            </mat-chip-list>
            </div>

            <div *ngIf="interaction.category">
            <mat-label style="font-size: 10px;">Category:</mat-label>
            <mat-chip-list (click)="openDetails(interaction.category)">
                <mat-chip class="chip-edit" color="primary" (click)="openDetails(interaction.category)"> 
                {{interaction.category}}
                </mat-chip>
            </mat-chip-list>
            </div>

            <div *ngIf="interaction.consult">
            <mat-label style="font-size: 10px;">Consult:</mat-label>
            <mat-chip-list>
                <mat-chip class="chip-edit" color="primary" (click)="openDetails(interaction.consult)"> 
                <!-- <app-smart-text [limit]="20" [text]="interaction.consult"></app-smart-text> -->
                </mat-chip>
            </mat-chip-list>
            </div>

            <div *ngIf="interaction.action">
            <mat-label style="font-size: 10px;">Action:</mat-label>
            <mat-chip-list>
                <mat-chip class="chip-edit" color="primary" (click)="openDetails(interaction.action)">
                <!-- <app-smart-text [limit]="20" [text]="interaction.action"></app-smart-text> -->
                </mat-chip>
            </mat-chip-list>
            </div>

            <div *ngIf="interaction.suggestion">
            <mat-label style="font-size: 10px;">Suggestion:</mat-label>
            <mat-chip-list>
                <mat-chip class="chip-edit" color="primary" (click)="openDetails(interaction.suggestion)">
                <!-- <app-smart-text [limit]="20" [text]="interaction.suggestion"></app-smart-text> -->
                </mat-chip>
            </mat-chip-list>
            </div>

            <div *ngIf="!isDateEmpty(interaction.date)">
            <mat-label style="font-size: 10px;">Created:</mat-label>
            <mat-chip-list class="chip-edit" >
                <mat-chip color="primary" (click)="openDetails(interaction.date)">
                <mat-icon>date_range</mat-icon>
                <app-date-render [date]="interaction.date" [format]="'short'"></app-date-render>
                </mat-chip>
            </mat-chip-list>
            </div>
            
        </div>

        <br>
        <button mat-stroked-button *ngIf="interaction.archived == 0" (click)="archiveInteraction(interaction.id)">Archive</button>

        <button *ngIf="interaction.completed == 0" (click)="completeInteraction($event,interaction.id)" mat-stroked-button>Mark as Done</button>
        <mat-chip *ngIf="interaction.completed == 1" color="accent" selected><i class="fas fa-check-circle"></i>Done</mat-chip>

    </mat-expansion-panel>

</mat-accordion>

<!-- VIDEOCALLS -->
<!-- <div class="tab-pane">
    <a href="javascript:void(0)" class="d-flex align-items-center media" *ngFor="let call of getVideocalls()">
        <div class="mb-0 me-2">
            <div class="main-img-user online">
                <img alt="" src="../assets/img/users/5.jpg"> <span>2</span>
            </div>
        </div>
        <div class="align-items-center justify-content-between">
            <div class="media-body ms-2">
                <div class="media-contact-name">
                        <span>{{call.action}}</span>
                        <span></span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="fe fe-arrow-up-right text-success me-2"></i>
                    <p class="text-muted tx-13">{{call.date}}</p>
                </div>
            </div>
        </div>
        <div class="ms-auto">
            <i class="contact-status text-success fe fe-phone-outgoing"></i>
        </div>
    </a>
</div> -->

<!-- End Row -->
<!-- <div class="row row-sm">
    <h3>Rellenar la interaccción:</h3>
    <mat-chip-list >
        <mat-chip class="chip-edit" color="primary" selected (click)="preFillInteraction('sentMinuta')"> 
            Enviamos minuta
            </mat-chip>
            <mat-chip class="chip-edit" color="primary" selected (click)="preFillInteraction('sentBudget')"> 
            Enviamos cotización
            </mat-chip>
            <mat-chip class="chip-edit" color="primary" selected (click)="preFillInteraction('checkpoint')"> 
            Cliente completa un requisito
            </mat-chip>
        <mat-chip class="chip-edit" color="primary" selected (click)="preFillInteraction('communication')"> 
            Cliente nos responde o notifica de un avance
        </mat-chip>
        
        </mat-chip-list>
</div> -->

<div class="row row-sm">
    <app-dynamic-crud [crudConfig]="config1" (formDataObj)="getCurrentObjFromForm($event)" [exportValuesFlag]="exportFlag"></app-dynamic-crud> 
</div>

<!-- VIDEOCALLS -->
<!-- <div class="tab-pane" id="ChatCalls">
    <a href="javascript:void(0)" class="d-flex align-items-center media" *ngFor="let call of getVideocalls()">
        <div class="mb-0 me-2">
            <div class="main-img-user online">
                <img alt="" src="../assets/img/users/5.jpg"> <span>2</span>
            </div>
        </div>
       <div class="align-items-center justify-content-between">
            <div class="media-body ms-2">
                <div class="media-contact-name">
                     <span>{{call.action}}</span>
                     <span></span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="fe fe-arrow-up-right text-success me-2"></i>
                    <p class="text-muted tx-13">{{call.date}}</p>
                </div>
            </div>
        </div>
        <div class="ms-auto">
            <i class="contact-status text-success fe fe-phone-outgoing"></i>
        </div>
    </a>
</div> -->